import useTranslation from "../../hooks/useTranslation";
import SurveyDispatch from "../../models/surveyDispatch";
import { ActionPlanIllustration } from "../../styles/illustrations/ActionPlanIllustration";
import { EventsResponse, SurveyType } from "../../types/actionPlan";
import { ActionPlanTimeline } from "../ActionPlanTimeline/ActionPlanTimeline";
import { DashboardWidget } from "../ui/DashboardWidget/DashboardWidget";

interface ActionPlanWidgetProps {
  surveyDispatch?: SurveyDispatch;
  eventsData?: EventsResponse[];
  error?: boolean;
  isLoading?: boolean;
  onActionPlanUpdate?: () => void;
}
export const ActionPlanWidget = ({
  surveyDispatch,
  eventsData,
  error,
  isLoading,
  onActionPlanUpdate,
}: ActionPlanWidgetProps) => {
  const { t } = useTranslation("dashboardPage");

  // Hack to filter out survey events from the events data
  // Only for demo purposes, as we will rewrite this component
  const eventWithoutSurveyEvents = eventsData?.filter(
    (event) =>
      event.meta?.type !== SurveyType.DueDate &&
      event.meta?.type !== SurveyType.Reminder &&
      event.meta?.type !== SurveyType.Launch
  );

  return (
    <DashboardWidget
      title={t("actionPlanWidget.title")}
      icon={ActionPlanIllustration}
      className="ActionPlanWidget"
      small
    >
      <ActionPlanTimeline
        surveyDispatch={surveyDispatch}
        eventsData={
          eventWithoutSurveyEvents?.length
            ? eventWithoutSurveyEvents
            : eventsData
        }
        error={error}
        isLoading={isLoading}
        onActionPlanUpdate={onActionPlanUpdate}
      />
    </DashboardWidget>
  );
};
